<template>
	<LabeledFieldLayout
		class="labeled-user-drop-down"
	>
		<TeamingUserDropDown
			:className="dropDownClassName"
			:value="userValue"
			:disabled="disabled"
			:userList="userList"
			@change="onChange"
		/>
	</LabeledFieldLayout>
</template>

<script>
import LabeledFieldLayout from "./LabeledFieldLayout";
import TeamingUserDropDown from "../TeamingUserDropDown";

export default {
	name: "LabeledUserDropDown",
	emits: [ "change", ],
	components: {
		TeamingUserDropDown,
		LabeledFieldLayout,
	},
	props: {
		value: {
			type: [ Object, String, ],
			default: () => ( {} ),
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		userList: {
			type: Array,
			default: () => [],
		},
		dropDownClassName: {
			type: String,
			default: "",
		},
	},
	computed: {
		userValue() {
			if ( this.value?.personId ) {
				return this.value;
			}
			return {
				personId: this.value,
			};
		},
	},
	methods: {
		onChange( option ) {
			this.$emit( "change", option );
		},
	},
};
</script>

<style lang="scss" scoped>
.labeled-drop-down {
	.teaming-drop-down {
		width: 100%;
	}
}
</style>
